import { useQuery } from 'react-query'

import { scanService } from 'src/services/scan.service'

import { QUERY_KEYS } from 'src/constants'
import { removeDefaultParams } from 'src/common/utils'
import { IFilter } from 'src/components/filter/types/filter.types'

export const initialScanDraftsFilter = {
  query: '',
}

export const useScanDrafts = (filter: IFilter) => {
  return useQuery(
    [QUERY_KEYS.SCAN_DRAFTS, filter],
    () => scanService.getDraftScans(removeDefaultParams(filter, initialScanDraftsFilter)),
    { keepPreviousData: true },
  )
}
